<div class=" bg-white dark:bg-black w-full lg:flex lg:justify-center p-10">
    <div class="max-w-960 w-full lg:w-[70%] flex flex-col text-title-color">
        <div class="flex">
            <span class="dark:text-white text-bold ayr-underline dark:text-shadow  ">{{"cities.video-container.header.integrated" |
                translate}}</span>
        </div>
        <div class="flex flex-col lg:flex-row lg:gap-2">
            <span class="text-bold dark:text-white"> {{ "cities.video-container.header.custom" | translate }}</span>
            <span class="text-bold dark:text-white"> {{ "cities.video-container.header.solutions" | translate }}</span>
        </div>
        <p class="mt-5 dark:text-white">
            {{ "cities.video-container.content" | translate }}
        </p>

        <video class="w-full self-center sm:w-[80%] mt-8" aria-label="Vídeo de apresentação do AYR"
            controls poster="https://storage.googleapis.com/weayr-assets-non-prod/images/cities/img-video-center.webp">
            <source src="https://video.wixstatic.com/video/e565ce_5faff7d590af4d089a9b8852ca399778/1080p/mp4/file.mp4"
                type="video/mp4" />
            Sorry, your browser doesn't support embedded videos.
        </video>
    </div>
</div>